import styles from './Trends.module.css'
import { NavLink } from '../ui'
import { useGlobalContext } from '../../lib/context';
import { ITrend, ITrendsCategoryType } from '../../interfaces';
type Props = {
    Selectedcategory?: string
    data?:ITrend[]
}
export function TrendsCategoryType({ Selectedcategory,data}: Props) {
    const { props: { countryCode } } = useGlobalContext()
    const siteURL = process.env.SITE_URL + "/" + countryCode;
    return (
        <div className={styles.incoBannerlist}>
            <div className="container">
                <ul>
                    <li className={`${!Selectedcategory ? styles.active : ""} font16 text000`} ><NavLink href={`${siteURL}/trends`}>All</NavLink></li>
                    {
                       data && data.map((category: ITrendsCategoryType) =>
                            <li key={category.cat_id} className={`${category.cat_slug == Selectedcategory ? styles.active : ""} font16 text000`}>
                                <NavLink href={`${siteURL}/trends/category/${category.cat_slug}`}>{category.cat_name}</NavLink></li>
                        )}
                </ul>
            </div>
        </div>
    )
}
